import jwt_decode from "jwt-decode";

interface ACCESS_TOKEN {
  exp: number;
  iss: string;
  aud: string;
  client_id: string;
  sub: string;
  auth_time: number;
  idp: string;
  role: string;
  name: string;
  given_name: string;
  profile: string;
  jti: string;
  iat: number;
  scope: string[];
  amr: string[];
}

// Decode Token:
export const decodeToken = (token: any) => {
  const decodedJwt: ACCESS_TOKEN = jwt_decode(token);
  return decodedJwt;
};

// Get DealerId From Token
export const getDealerIdFromToken = (token: any) => {
  const decodedJwt = decodeToken(token);
  // Get the profile object from token:
  const profileObj = JSON.parse(decodedJwt.profile);
  const dealerId = profileObj.dealerId;
  return dealerId;
};

/**
 * Allowed parent origins for cross-origin postMessage communication.
 * Parsed from the REACT_APP_ALLOWED_PARENT_ORIGINS env var (comma-separated).
 */
export const ALLOWED_PARENT_ORIGINS: string[] =
  process.env.REACT_APP_ALLOWED_PARENT_ORIGINS?.split(",").map(s => s.trim()).filter(Boolean) ?? [];

/**
 * Appends the `hostOrigin` query param (if present) to a Customer Portal route, so the
 * next page can keep requesting config from the same embedding host via postMessage.
 */
export const withHostOrigin = (path: string, hostOrigin: string | null): string =>
  path + (hostOrigin ? `?hostOrigin=${encodeURIComponent(hostOrigin)}` : "");

export const getBaseUrlWithoutLastPath = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    const segments = parsedUrl.pathname.split("/").filter(Boolean);

    if (segments.length > 0) {
      segments.pop(); // Remove the last segment
      parsedUrl.pathname = "/" + segments.join("/");
    } else {
      parsedUrl.pathname = "";
    }

    return parsedUrl.toString().replace(/\/$/, ""); // remove trailing slash
  } catch (err) {
    return "";
  }
};
